export default "__VITE_ASSET__zWo2pnxn__"